import { render, staticRenderFns } from "./RewardItem.vue?vue&type=template&id=b07b5e3a&"
import script from "./RewardItem.vue?vue&type=script&lang=ts&"
export * from "./RewardItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports